import React, { useContext, useState, useMemo } from 'react';
import Card from "react-bootstrap/Card";
import Help from "../../buttons/Help";
import TextComponent from "../components_parts/TextComponent";
import ComponentLockButton from "../../buttons/ComponentLockButton";
import { Collapse } from "react-bootstrap";
import { LogicContext } from '../../logicContext';
import produce from 'immer';
const languageHelp = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "A first-order language is defined in this section."), /*#__PURE__*/React.createElement("p", null, "The Edit/Done button toggles between editing the language and viewing it in a more compact form."), /*#__PURE__*/React.createElement("p", {
  className: "mb-0"
}, "Syntactic requirements:"), /*#__PURE__*/React.createElement("ul", {
  className: "mb-0"
}, /*#__PURE__*/React.createElement("li", null, "Symbols in all sets are ", /*#__PURE__*/React.createElement("strong", null, "comma-separated"), "."), /*#__PURE__*/React.createElement("li", null, "Each predicate and function symbol must be followed by a slash (", /*#__PURE__*/React.createElement("code", null, "/"), ") and arity (the number of arguments the symbol takes, a positive integer):", " ", /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("code", null, "symbol/arity")), ".")));

function constantComponent(props) {
  if (props.language.lockedComponent) {
    return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "\uD835\uDCD2", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"), " ", props.language.constants.parsed.join(', '), " }");
  } else {
    return /*#__PURE__*/React.createElement(TextComponent, {
      labelText: "Individual constant",
      errorProperty: props.language.constants.errorMessage,
      onChangeSetFunction: props.setConstants,
      onLockFunction: props.lockConstants,
      textData: props.language.constants,
      textInputLabel: /*#__PURE__*/React.createElement("span", null, "\uD835\uDCD2", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"),
      teacherMode: props.teacherMode,
      idName: 'language-editor-constants'
    });
  }
}

function predicateComponent(props) {
  if (props.language.lockedComponent) {
    return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "\uD835\uDCDF", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"), " ", props.language.predicates.parsed.map(tuple => tuple.name + '/' + tuple.arity).join(', '), " }");
  } else {
    return /*#__PURE__*/React.createElement(TextComponent, {
      labelText: "Predicate symbols",
      errorProperty: props.language.predicates.errorMessage,
      onChangeSetFunction: props.setPredicates,
      onLockFunction: props.lockPredicates,
      textData: props.language.predicates,
      textInputLabel: /*#__PURE__*/React.createElement("span", null, "\uD835\uDCDF", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"),
      teacherMode: props.teacherMode,
      idName: 'language-editor-predicates'
    });
  }
}

function functionComponent(props) {
  if (props.language.lockedComponent) {
    return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "\uD835\uDCD5", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"), " ", props.language.functions.parsed.map(tuple => tuple.name + '/' + tuple.arity).join(', '), " }");
  } else {
    return /*#__PURE__*/React.createElement(TextComponent, {
      labelText: "Function symbols",
      errorProperty: props.language.functions.errorMessage,
      onChangeSetFunction: props.setFunctions,
      onLockFunction: props.lockFunctions,
      textData: props.language.functions,
      textInputLabel: /*#__PURE__*/React.createElement("span", null, "\uD835\uDCD5", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"),
      teacherMode: props.teacherMode,
      idName: 'language-editor-functions'
    });
  }
}

const Language = props => {
  const [showHelp, setShowHelp] = useState(false);
  const context = useContext(LogicContext); // load language from context when context is present

  useMemo(() => {
    context && props.setConstants(context.constants.join(', '), true);
  }, [context?.constants]);
  useMemo(() => {
    context && props.setPredicates(context.predicates.map(({
      name,
      arity
    }) => `${name}/${arity}`).join(', '), true);
  }, [context?.predicates]);
  useMemo(() => {
    context && props.setFunctions(context.functions.map(({
      name,
      arity
    }) => `${name}/${arity}`).join(', '), true);
  }, [context?.functions]); // force lock language when context is present

  context && (props = produce(props, draft => {
    draft.language.lockedComponent = true;
  }));
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    as: "h5",
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("span", null, "Language \uD835\uDCDB"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-left"
  }, !context && /*#__PURE__*/React.createElement(ComponentLockButton, {
    lockFn: () => props.lockLanguageComponent(),
    locked: props.language.lockedComponent,
    subject: "language"
  }), /*#__PURE__*/React.createElement(Help, {
    subject: "language",
    children: languageHelp,
    onToggle: setShowHelp,
    show: showHelp
  }))), /*#__PURE__*/React.createElement(Card.Body, null, constantComponent(props), predicateComponent(props), functionComponent(props)));
};

export default Language;